import { ConfigDataInterface } from './ConfigApiInterface';
import { Config_Club_PageMenu_ApiEnum } from './ClubDetailConfigApiInterface';

export enum Config_ClubAccountTransactions_ActionsMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export enum Config_ClubAccountTransactions_Modules_ApiEnum {
    'indications' = 'indications',
    'overview' = 'overview',
    'results' = 'results',
}

export enum Config_ClubAccountTransactions_ActionsOther_ApiEnum {
    'upload_photo' = 'upload_photo',
}

export enum Config_ClubAccountTransactions_PageSubMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export interface Config_ClubAccountTransactions_ApiInterface
    extends ConfigDataInterface<
        Config_ClubAccountTransactions_Modules_ApiEnum,
        Config_ClubAccountTransactions_ActionsMenu_ApiEnum,
        Config_ClubAccountTransactions_ActionsOther_ApiEnum,
        Config_Club_PageMenu_ApiEnum,
        Config_ClubAccountTransactions_PageSubMenu_ApiEnum
    > {
    _?: boolean;
}
